import React from "react";
import 'bootstrap/dist/css/bootstrap.css'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import Home from "./pages/home-page/Home";
import JobseekerLogin from "./pages/login-page/jobseekerlogin";
import EmployerLogin from "./pages/login-page/employerlogin";
import EmployerSignup from "./pages/signup-page/Employer/employer-signup";
import JobSeekerSignup from "./pages/signup-page/Job-Seeker/job-seeker-signup";
import Footer from "./components/footer/Footer";
import EmployerProfile from "./pages/profile/Employer/Profile/employer-profile";
import JobSeekerProfile from "./pages/profile/Job Seeker/Profile/job-seeker-profile";
import Message from "./pages/profile/Job Seeker/Messages/message";
import NewMessage from "./pages/profile/Job Seeker/Messages/new-message";
import Notifications from "./pages/profile/Job Seeker/Notifications/notifications";
import Dashboard from "./pages/profile/Job Seeker/Dashboard/dashboard";
import Jobs from "./pages/profile/Job Seeker/Jobs/jobs";
import Assess from "./pages/profile/Job Seeker/Assessment/assess";
import Settings from "./pages/profile/Job Seeker/Settings/settings";
import JobAlert from "./pages/profile/Job Seeker/Job-Alert/alert";
import FindJobs from "./pages/profile/Job Seeker/Find-Jobs/find";
import Details from "./pages/profile/Job Seeker/Assessment/details";
import ReadMore from "./pages/profile/Job Seeker/Find-Jobs/readmore";
import EmployerSettings from "./pages/profile/Employer/Settings/employer-settings";
import EmployerNotifications from "./pages/profile/Employer/Notifications/employer-notifications";
import EmployerMessages from "./pages/profile/Employer/Messages/employer-messages";
import EmployerNewMessages from "./pages/profile/Employer/Messages/employer-new-messages";
import Feedback from "./pages/profile/Employer/Post-Feedback/feedback";
import Form1 from "./pages/signup-page/employer-form/form1";
import Form2 from "./pages/signup-page/employer-form/form2";
import Employerform1 from "./pages/signup-page/employer-form/employerform1";
import Employerform2 from "./pages/signup-page/employer-form/employerform2";
import Employerform3 from "./pages/signup-page/employer-form/employerform3";
import EmployerDashboard from "./pages/profile/Employer/Dashboard/employer-dashboard";
import PostJobs from "./pages/profile/Employer/Post-Jobs/postjobs";
import Jobdescription from "./pages/profile/Employer/Post-Jobs/jobdescription";


function App() {
  return (
    <Router>
      
      <Routes>
        <Route exact path='/' element={<Home/>}/>
        
        <Route path='/jobseekerlogin' element={<JobseekerLogin/>}/>
        <Route path='/employerlogin' element={<EmployerLogin/>}/>
        <Route path='/jobseekersignup' element={<JobSeekerSignup/>}/>
        <Route path='/employersignup' element={<EmployerSignup/>}/>
        <Route path='/employerprofile' element={<EmployerProfile/>}/>
        <Route path='/jobseekerprofile' element={<JobSeekerProfile/>}/>
        <Route path='/messages' element={<Message/>}/>
        <Route path='/newmessage' element={<NewMessage/>}/>
        <Route path='/notifications' element={<Notifications/>}/>
        <Route path='/dashboard' element={<Dashboard/>}/>
        <Route path='/jobs' element={<Jobs/>}/>
        <Route path='/assessments' element={<Assess/>}/>
        <Route path='/settings' element={<Settings/>}/>
        <Route path='/jobalert' element={<JobAlert/>}/>
        <Route path='/find' element={<FindJobs/>}/>
        <Route path='/read-more/:id' element={<ReadMore/>}/>
        <Route path='/details' element={<Details/>}/>
        <Route path='/employersettings' element={<EmployerSettings/>}/>
        <Route path='/employermessages' element={<EmployerMessages/>}/>
        <Route path='/employernewmessages' element={<EmployerNewMessages/>}/>
        <Route path='/employernotifications' element={<EmployerNotifications/>}/>
        <Route path='/feedback' element={<Feedback/>}/>
      
        <Route path='/form1' element={<Form1/>} />
        <Route path='/form2' element={<Form2/>} />
        <Route path='/employerform1' element={<Employerform1/>} />
        <Route path='/employerform2' element={<Employerform2/>} />
        <Route path='/employerform3' element={<Employerform3/>} />
        <Route path='/employerdashboard' element={<EmployerDashboard/>}/>
        <Route path='/postjobs' element={<PostJobs/>}/>
        <Route path='/jobdescription' element={<Jobdescription/>}/>

      </Routes>
      
     
      <Footer/>
      
    </Router>
  )
}

export default App;
